import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';

const MOCK_WINS = [
  { hand: 'Royal Flush', time: 2, location: 'Las Vegas, NV', winnings: '$125,000', avatar: '🎰' },
  { hand: 'Straight Flush', time: 15, location: 'Atlantic City, NJ', winnings: '$28,500', avatar: '🃏' },
  { hand: 'Four of a Kind', time: 32, location: 'Monaco', winnings: '$15,200', avatar: '👑' },
];

const RecentBigWins = ({ playersOnline = 185 }) => {
  const { t } = useLanguage();

  return (
    <div className="mt-6">
      {/* Header */}
      <div className="flex items-center justify-center gap-6 mb-4">
        <div 
          className="px-6 py-2 rounded-full flex items-center gap-3"
          style={{
            background: 'linear-gradient(145deg, rgba(26,26,46,0.95), rgba(22,33,62,0.95))',
            border: '1px solid rgba(255,215,0,0.3)',
            boxShadow: '0 4px 15px rgba(0,0,0,0.3)'
          }}
        >
          <span className="text-lg">🏆</span>
          <span className="font-bold tracking-wider" style={{ color: '#ffd700' }}>{t('recentJackpots')}</span>
        </div>
        
        <div 
          className="px-4 py-2 rounded-full flex items-center gap-2"
          style={{
            background: 'linear-gradient(145deg, #00ff88, #00cc6a)',
            boxShadow: '0 0 20px rgba(0,255,136,0.3)'
          }}
        >
          <div className="w-2 h-2 rounded-full bg-white animate-pulse"></div>
          <span className="font-bold text-sm" style={{ color: '#1a1a2e' }}>
            {playersOnline} {t('playersOnline')}
          </span>
        </div>
      </div>

      {/* Wins Carousel */}
      <div className="flex justify-center gap-4 overflow-x-auto pb-2">
        {MOCK_WINS.map((win, index) => (
          <div 
            key={index}
            className="flex-shrink-0 p-4 rounded-xl min-w-[220px] transform transition-all hover:scale-105 hover:-translate-y-1"
            style={{
              background: 'linear-gradient(145deg, rgba(26,26,46,0.95), rgba(22,33,62,0.95))',
              border: '1px solid rgba(255,215,0,0.2)',
              boxShadow: '0 4px 20px rgba(0,0,0,0.3)'
            }}
          >
            <div className="flex items-center gap-3 mb-2">
              <div 
                className="w-10 h-10 rounded-full flex items-center justify-center text-xl"
                style={{
                  background: 'linear-gradient(145deg, #ffd700, #b8860b)',
                  boxShadow: '0 0 10px rgba(255,215,0,0.3)'
                }}
              >
                {win.avatar}
              </div>
              <div>
                <div className="font-bold text-sm" style={{ color: '#ffd700' }}>{win.hand}</div>
                <div className="text-xs" style={{ color: '#666' }}>{win.time} {t('minAgo')}</div>
              </div>
            </div>
            <div className="text-xs mb-1" style={{ color: '#888' }}>📍 {win.location}</div>
            <div 
              className="text-xl font-black"
              style={{ 
                background: 'linear-gradient(180deg, #00ff88, #00cc6a)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent'
              }}
            >
              {win.winnings}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RecentBigWins;
